export default "__VITE_ASSET__95d51ebc__"